import { useCallback, useEffect, useMemo } from "react"
import { useSelector } from "react-redux"
import _flatMapDeep from "lodash/flatMapDeep"

import { getDateByTimezone } from "utils/utils"

import useGetMotibellMainListQuery from "hooks/queries/motibell/useGetMotibellMainListQuery"

const useMotibellMainList = ({ scrollRef }) => {
  const scrollRefCurr = scrollRef.current
  const userInfo = useSelector((state) => state.userInfo)

  const CURR_DATE = getDateByTimezone("Asia/Seoul")

  const { data, isLoading, fetchNextPage, isFetching } = useGetMotibellMainListQuery(
    {
      userNo: userInfo.user_no || undefined,
      currDate: CURR_DATE,
    },
    {
      cacheTime: 0,
    }
  )

  const motibellItems = useMemo(() => {
    if (!data) return null
    return _flatMapDeep(data.pages, ({ data }) => [...data.motibells])
  }, [data])

  const getMotibellStatus = useCallback(
    ({ dueDate, endDate, currCapacity, maxCapacity, isJoin }) => {
      const currDate = CURR_DATE
      if (currDate > endDate) {
        return {
          bgColor: "#C4C4C4",
          text: "마감",
          isActive: false,
        }
      } else if (isJoin === true) {
        return {
          bgColor: "#1FC2A4",
          text: "참여 중",
          isActive: true,
        }
      } else if (currDate > dueDate) {
        return {
          bgColor: "#C4C4C4",
          text: "마감",
          isActive: false,
        }
      } else if (maxCapacity) {
        if (currCapacity === maxCapacity) {
          return {
            bgColor: "#C4C4C4",
            text: "마감",
            isActive: false,
          }
        }
        return {
          bgColor: "#FF9B57",
          text: "선착순",
          isActive: true,
        }
      } else {
        return {
          bgColor: "#FF9B57",
          text: "참여 가능",
          isActive: true,
        }
      }
    },
    [CURR_DATE]
  )

  const handlePageScroll = useCallback(
    async (evt) => {
      const { scrollHeight, scrollTop, clientHeight } = evt.target
      const isFetch = scrollHeight - scrollTop <= clientHeight

      if (isFetch && !isFetching) {
        fetchNextPage()
      }
    },
    [fetchNextPage, isFetching]
  )

  useEffect(() => {
    if (scrollRefCurr) {
      scrollRefCurr.addEventListener("scroll", handlePageScroll)
    }

    return () =>
      scrollRefCurr ? scrollRefCurr.removeEventListener("scroll", handlePageScroll) : ""
  }, [handlePageScroll, scrollRefCurr])

  return { motibellItems, isLoading, isFetching, getMotibellStatus }
}

export default useMotibellMainList
